import useRequest from '@space-shell/common/hooks/useRequest'
import { ProductEndpoints, ProductService } from '@space-shell/common/services/product'
import { useMembershipStore } from '@space-shell/core/store'

import { useOptionalShowcase } from '../useOptionalShowcase'

export const useDefaultProductRequest = () => {
  const { membershipData } = useMembershipStore()
  const { showcaseEnabled } = useOptionalShowcase()
  const membershipId = String(membershipData?.id)

  return useRequest(
    [ProductEndpoints.getDefault(membershipId)],
    () => ProductService.getDefaultProduct(membershipId),
    {
      enabled: !showcaseEnabled
    }
  )
}
